import { ca } from '@cian/analytics';

export function trackTableScroll() {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'Compare',
    action: 'scroll_sopr',
    label: 'flats',
    page: {
      siteType: 'desktop',
      pageType: 'ListingCompare',
    },
  });
}
